import cn from "classnames";
import s from "./Cells.module.scss";
import { ImageWrapper } from "@widgets/components";

type DataItem = {
  ranking: 9;
  instrumentId: "11831";
  name: "";
  label: "ALEC";
  icon: "images/logos/iex/ALEC.png";
  "Largest Market Out and Under Performers": "-52.2%";
  "Total 1 Yr Return": "-38.9%";
  "Potential breakouts": "+77.3%";
  "Potential breakdowns": "+34.2%";
  "Average Up Day Price Move": "3.0%";
  "Average Down Day Price Move": "-3.6%";
  "Up Days": "134";
  "Down Days": "116";
};
export const InstrumentCell = ({
  dataItem,
  field,
  onClick,
}: {
  field: keyof DataItem;
  dataItem: DataItem;
  onClick: (id: string) => void;
}) => {
  return (
    <div
      style={{ cursor: "pointer" }}
      onClick={() => onClick?.(dataItem?.instrumentId)}
      className={s.instrumentCell}
    >
      {dataItem?.icon ? (
        <div className={s.imageWrapper}>
          <ImageWrapper
            src={`https://cdn.illio.com/${dataItem?.icon}`}
            alt={`${dataItem.label} logo`}
            className={cn(s.image)}
          />
        </div>
      ) : (
        <div className={cn(s.image)}>{dataItem.label?.substring(0, 5)}</div>
      )}
      <div>
        {dataItem.label}
        <br />
        {dataItem.name}
      </div>
    </div>
  );
};
